/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import SignatureCanvas from 'react-signature-canvas';
import styles from './fields.module.scss';
import { fetchDataSoureValues, clearDataSourceValues } from '../../modules/inspections/redux/actions';
import InspectionChecklist from './inspection_checklist/inspection_checklist';
import TooltipWithHeading from '../../components/helpToolTip/ToolTip';
import Button from '../../components/button';
import Select from './select/Select';
import { fetchselectedUsers, getPortalusersForPortaUserlField } from '../../modules/forms/redux/actions';
import { getAvpGlobalDataSource } from '../../modules/PermitManagement/redux/action';
import DataSourceInformation from './datasourceInformation';
import woStyles from '../../modules/workorders/Detail/workOrderDetail.module.scss';

class PulpoField extends Component {
  constructor(props) {
    super(props);

    const { type: fieldType } = props;
    const resolvedFieldType = ({
      dateWithSeconds: 'datetime',
      datetimeWithSeconds: 'datetime',
      timeWithSeconds: 'time',
      only_time_with_seconds: 'time'
    })[fieldType] || fieldType;
    if (
      fieldType !== 'inspection_checklist'
      && fieldType !== 'signature'
      && fieldType !== 'user_dropdown'
      && fieldType !== 'suffix'
      && fieldType !== 'dataSource-ds6'
    ) {
      // eslint-disable-next-line global-require, import/no-dynamic-require
      let component = require(`./${resolvedFieldType}`);
      if (component.default) {
        component = component.default;
      }
      this.component = component;
    }
    this.state = { errors: [], dataSourceValues: undefined };
    this.sigCanvas = new Map();
    this.updateFieldErrors = this.updateFieldErrors.bind(this);
    this.portalDataSourcesUrl = {
      ds5: '/get_tenants/',
      ds1: '/get_lease_properties/',
      ds8: '/generic_datasource/',
      ds7: '/get_notams/',
      ds2: '/get_locations/',
      ds9: '/get_tail_numbers/',
      ds3: '/get_asset_registry/',
      ds10: '/wildlife_species/',
      ds6: '/form/get_form_data/'
    };
  }

  componentDidMount() {
    const { actionDataSource, allDataSources, dataSourceID, type, publicForm, id, signData, fetchPortalUsersList,
      forSmsPublic, filters, actionFetchSelectedUsers, canUseDataSourceFromAvp, actionGetAvpGlobalDataSource } = this.props;
    if (type?.includes('dataSource') && !publicForm && allDataSources && !this.portalDataSourcesUrl[dataSourceID]) {
      const source = allDataSources.filter(e => (e.name === dataSourceID));
      if (source.length > 0) {
        actionDataSource(source[0].metadata.method, undefined, source[0].metadata?.portal_url);
      }
    }
    if (type?.includes('dataSource') && !publicForm && this.portalDataSourcesUrl[dataSourceID] && !forSmsPublic) {
      let url = `/portal${this.portalDataSourcesUrl[dataSourceID]}`;
      if (dataSourceID === 'ds6') {
        url = this.portalDataSourcesUrl[dataSourceID];
      }
      if (canUseDataSourceFromAvp && this.props?.global_location?.key && this.props?.settings?.unusedGlolbalDataSource) {
        actionGetAvpGlobalDataSource(this.props?.global_location?.key, id);
      } else {
        actionDataSource(
          'get',
          undefined,
          url,
          id,
          filters
        );
      }
    }
    if (type === 'user_dropdown') {
      actionFetchSelectedUsers();
    }
    if (this.props?.widget?.type === 'portal_user') {
      fetchPortalUsersList();
    }
    if (signData) {
      Object.entries(this.props.signData).forEach((item) => {
        if (this.sigCanvas[item[0]]) {
          this.sigCanvas[item[0]].fromData(item[1]);
        }
      });
    }
  }

  componentWillUnmount() {
    const { actionClear } = this.props;
    actionClear();
  }

  static getDerivedStateFromProps(props, state) {
    if (!state.dataSourceValues && props.dataSourceValues && props.dataSourceValues.length >= 0) {
      return { ...state,
        dataSourceValues: props.dataSourceValues?.map(e => ({
          key: `${e.name}${e.description ? ` ${e.description}` : ''}`,
          value: `${e.name}${e.description ? ` ${e.description}` : ''}`,
          ...e
        })) };
    }
    if (props.publicForm) {
      if (!state.dataSourceValues) {
        const combinedDataSourceValues = [
          ...(props.locations?.length > 0 ? props.locations : []),
          ...(props.datasources?.length > 0 ? props.datasources : [])
        ];
        if (combinedDataSourceValues.length > 0) {
          return { ...state, dataSourceValues: combinedDataSourceValues };
        }
      }
    }
    if (props.forSmsPublic) {
      if (!state.dataSourceValues) {
        if (props.datasources?.length > 0) {
          return { ...state, dataSourceValues: props.datasources };
        }
      }
    }
    return state;
  }

  handleSign = (fieldId) => {
    const { handleValueChange, handleFieldErrorChanged, handleSignData, isInsCompleted } = this.props;
    if (this.sigCanvas[fieldId].getTrimmedCanvas().toDataURL('image/png')) {
      const signatureFile = this.dataURLtoFile(this.sigCanvas[fieldId].getTrimmedCanvas().toDataURL('image/png'), `${fieldId}.png`);
      handleValueChange(signatureFile, fieldId);
      if (!isInsCompleted) {
        handleSignData(fieldId, this.sigCanvas[fieldId].toData());
      }
      handleFieldErrorChanged(fieldId, false);
    }
  }

  dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(',');


    const mime = arr[0].match(/:(.*?);/)[1];


    const bstr = atob(arr[1]);


    let n = bstr.length;


    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  signClear = (fieldId, isRequired) => {
    const { handleValueChange, handleFieldErrorChanged } = this.props;
    this.sigCanvas[fieldId].clear();
    handleValueChange('', fieldId);
    if (isRequired) {
      handleFieldErrorChanged(fieldId, true);
    } else {
      handleFieldErrorChanged(fieldId, false);
    }
  }

  updateFieldErrors(errors) {
    this.setState({ errors });
  }

  render() {
    const {
      id: fieldId,
      type: fieldType,
      title,
      multiFieldId,
      allFields,
      isRequired,
      showFieldErrors,
      className,
      translationID,
      translation,
      dataSourceID,
      Badging,
      forFormModule,
      customError,
      globalLeaseProperties,
      customFields,
      answers,
      requiredMargin,
      fromSMS,
      fullWidth,
      newPublicForm,
      handleUseHelpText,
      standform,
      forSmsPublic,
      fromMultiGrid,
      myforms,
      exposeSign,
      dateEditable,
      validators,
      fieldErrors,
      selected_users,
      dataSource_values,
      popoverMultiEmail,
      forQuestionMarkHelp,
      customStyles,
      hideMandatorySign = false,
      ...fieldProps
    } = this.props;
    const multiField = Array.isArray(allFields)
  ? allFields.find(f => f.id === fieldId)
  : null;
    const { errors, dataSourceValues } = this.state;
    let acceptedUsers = selected_users?.dropdown_users;
    if (this.props?.settings?.systemUserFieldSelectedRoles?.length) {
      // FILTER SELECTED ROLE USERS
      acceptedUsers = selected_users?.dropdown_users
      ?.filter(eachRole => eachRole.roles?.some(useRole => this.props?.settings?.systemUserFieldSelectedRoles
      ?.some(selectedRole => selectedRole.value === useRole.id)));
    }
    const selectedUserNames = acceptedUsers?.map(item => ({ key: item.id, value: item.fullname })) || [];
    const smsLang = localStorage.getItem('lang') === 'az';
    return (
      <div className={fromMultiGrid ? `${styles.field} ${className} ${styles.multi_grid}` : `${styles.field} ${className}`} style={customStyles}>
        {!fieldType?.includes('MultiLevel') && fieldType !== 'dataSource-ds6' && (
          <span className={styles.title} style={{ color: smsLang ? '#2e406b' : '' }}>
            { isRequired && !hideMandatorySign && (
              <small style={requiredMargin
                  ? { position: 'relative', top: '35px', color: 'red' }
                  : { color: 'red' }
              }>
                *
              </small>
            )}
            {/* Badging Initiate Application checkbox ui */}
            {Badging && fieldType === 'boolean' && React.createElement(
              this.component,
              {
                ...fieldProps,
                fieldId,
                fieldType,
                isRequired,
                Badging,
                updateFieldErrors: this.updateFieldErrors
              }, null
            )}
            {!Badging && fieldType === 'boolean' && React.createElement(
              this.component,
              {
                ...fieldProps,
                fieldId,
                fieldType,
                isRequired,
                Badging,
                updateFieldErrors: this.updateFieldErrors
              }, null
            )}
            {translation || <FormattedMessage id={translationID} defaultMessage={title|| fieldProps.description} />}
            {(fromSMS || newPublicForm || myforms || forQuestionMarkHelp) && fieldProps?.description?.length > 0 && (
              <TooltipWithHeading
                title="Help"
                toolTip={`form.setting.newfield.helptext.${fieldProps.description}`}
                text={fieldProps.description}
                values={fieldProps.description}
              />
            )}
             {(popoverMultiEmail || (fieldType === 'string' && multiField?.validators?.[0]?.multiple_email)) && (
              <TooltipWithHeading
                title="Email Instructions"
                toolTip="email.instructions.tooltip"
                text="Please press Enter after typing each email. If pasting multiple emails, separate them using a comma (,)."
                values={{}}
              />
            )}
            {fieldProps?.description?.length > 0 && standform && (
              <span>
               {handleUseHelpText}
              </span>
            )}
            {!standform && !fromSMS && !newPublicForm && !myforms && !forQuestionMarkHelp
            && fieldProps?.description?.length > 0 && (
              <span>
                <pre className={styles.description}>
                  {fieldProps.description}
                </pre>
              </span>
            )}
          </span>
        )}
        {(Badging && fieldType !== 'boolean' && fieldType !== 'suffix') && fieldType !== 'signature'
        && fieldType !== 'user_dropdown' && (!fieldType?.includes('dataSource'))
        && (
          React.createElement(
            this.component,
            {
              ...fieldProps,
              fieldId,
              fieldType,
              isRequired,
              Badging,
              validators,
              fields: customFields,
              allFields,
              answers,
              dateEditable,
              calculationField: fieldProps.answer,
              showFieldErrors,
              fullWidth,
              updateFieldErrors: this.updateFieldErrors
            }, null
          ))}
          {(!Badging && fieldType !== 'boolean' && fieldType !== 'suffix' && !fieldType?.includes('dataSource'))
            && fieldType !== 'signature' && fieldType !== 'user_dropdown'
            && fieldType !== 'inspection_checklist'
            && (
            React.createElement(
              this.component,
              {
                ...fieldProps,
                fieldId,
                fieldType,
                isRequired,
                showFieldErrors,
                allFields,
                multiFieldId,
                answers,
                fromMultiGrid,
                validators,
                updateFieldErrors: this.updateFieldErrors
              }, null
            ))}
          {fieldType === 'dataSourceMultiLevel' && (dataSourceValues|| fieldProps?.values)
            && (
            <div className={!customStyles
              ? forSmsPublic ? styles.dataSourceLoc1 : forFormModule ? styles.dataSourceLocForm : styles.dataSourceLoc : ''}>
              {React.createElement(
                this.component,
                {
                  ...fieldProps,
                  fieldId,
                  fieldType,
                  isRequired,
                  title,
                  values: forFormModule ? fieldProps.values : dataSourceValues,
                  answer: fieldProps.answer,
                  showFieldErrors,
                  errors,
                  updateFieldErrors: this.updateFieldErrors,
                  forFormModule
                },
                null
              )}
            </div>
          )}
        {(fieldType === 'dataSource' || fieldType === 'dataSourceMultiselect') && dataSourceValues && dataSourceID !== 'ds9'
          && this.portalDataSourcesUrl[dataSourceID] && React.createElement(
          this.component,
          {
            ...fieldProps,
            fieldId,
            fieldType,
            fullWidth,
            fromMultiGrid,
            isRequired,
            values: dataSourceValues,
            dataSourceID,
            allFields,
            updateFieldErrors: this.updateFieldErrors
          }, null
        )}
        {(fieldType === 'dataSource' || fieldType === 'dataSourceMultiselect')
          && dataSource_values?.length > 0 && dataSourceID === 'ds9'
          && React.createElement(
            this.component,
            {
              ...fieldProps,
              fieldId,
              fieldType,
              fullWidth,
              isRequired,
              dataSource_values,
              dataSourceID,
              values: dataSource_values.map(value => (
                { key: value,
                  value,
                  label: value,
                  text: value
                }
              )),
              updateFieldErrors: this.updateFieldErrors
            }, null
        )}
        {fieldType === 'signature' && (
            <div className={styles.signature}>
              {fieldProps.answer && fieldProps.answer?.[0]?.url && (
                <img src={fieldProps.answer[0].url} alt="" className={exposeSign ? styles.signImage : ''} />
              )}
              <div style={fieldProps.answer && fieldProps.answer.length ? { display: 'none' } : { display: 'block' }}>
                <SignatureCanvas
                  ref={(ref) => { this.sigCanvas[fieldId] = ref; }}
                  penColor="black"
                  canvasProps={{ width: 778, height: 152, className: exposeSign ? styles.signImage : styles.sigCanvas }}
                  onEnd={() => this.handleSign(fieldId)}
                />
              </div>
              <Button
                action="tertiary"
                onClick={() => this.signClear(fieldId, isRequired)}
                translationID="filters.form.clear"
                defaultText="clear"
                className={exposeSign ? `${styles.button} ${styles.signClearBtn}` : styles.button}
              />

              {showFieldErrors && isRequired && (
                <small style={{ color: 'red' }}>
                  {(!fieldProps.answer || (fieldProps.answer.length === 0)) && (
                    <FormattedMessage id="pulpoforms.errors.not_blank"
                      defaultMessage="This field cannot be empty"
                    />
                  )}
                </small>
              )}
            </div>
        )
        }
        {fieldType === 'user_dropdown'
          && (
            <Select
              selected_users={selectedUserNames}
              fieldId={fieldId}
              fieldType={fieldType}
              isRequired={isRequired}
              updateFieldErrors={this.updateFieldErrors}
              {...fieldProps}
              widget={{ type: 'user_dropdown' }}
            />)
          }
        {Badging && fieldType === 'suffix'
          && (
            <Select
              fieldId={fieldId}
              fieldType={fieldType}
              isRequired={isRequired}
              updateFieldErrors={this.updateFieldErrors}
              {...fieldProps}
            />)
        }
        {fieldType === 'inspection_checklist'
          && (
            <>
              <InspectionChecklist
                fieldId={fieldId}
                fieldType={fieldType}
                isRequired={isRequired}
                answer={fieldProps.answer}
                updateFieldErrors={this.updateFieldErrors}
                {...fieldProps}
              />
              {showFieldErrors && fieldErrors[fieldId] && isRequired && (
                <small style={{ color: 'red' }}>
                  <FormattedMessage id="pulpoforms.errors.answer.all"
                    defaultMessage="Please make sure you've answered all of the checklists."
                  />
                </small>
              )}
            </>)
          }
        {showFieldErrors && !fieldType?.includes('MultiLevel')
          && (customError? <small>{customError}</small>
            : errors.map(e => (
              <small key={e}>
                <FormattedMessage
                  id={e?.id || e}
                  defaultMessage="There is an error in this field"
                  values={e?.values}
                />
              </small>
            )))
        }
        {fieldProps?.standRequest
          && showFieldErrors
          && (fieldType === 'string' || fieldType === 'telephone')
          && validators && validators?.length > 0
          && validators[0]?.value
          && (validators[0]?.label === 'Phone Number' || validators[0]?.label === 'Email' || validators[0]?.label === 'Custom Validation')
          && answers?.[fieldId] && fieldErrors?.[fieldId]
          && (
          <small key={'12'}>
              <FormattedMessage
                id={'12'}
                defaultMessage="There is an error in this field"
              />
          </small>
        )}
        { dataSourceID === 'ds5' && fieldProps?.source_fields?.length > 0 && fieldProps?.answer &&(
        <div className={`${woStyles.requestInfo}`}>
          <DataSourceInformation
            sourceFields={fieldProps?.source_fields}
            dataSourceValues={dataSourceValues}
            answer={fieldProps?.answer} />
        </div>
        )}
      </div>
    );
  }
}


PulpoField.propTypes = {
  type: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  handleValueChange: PropTypes.func.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  showFieldErrors: PropTypes.bool.isRequired,
  className: PropTypes.string,
  translationID: PropTypes.string,
  forQuestionMarkHelp: PropTypes.bool
};

PulpoField.defaultProps = {
  className: '',
  translationID: 'invalid',
  isRequired: false,
  forQuestionMarkHelp: false
};

const mapStateToProps = (state, props) => ({
    dataSourceValues: (props.dataSourceID === 'ds8' && props.canUseDataSourceFromAvp && props?.settings?.unusedGlolbalDataSource)
      ? get(state, `permitManagement.avpGlobalDatasourceList[${get(props, 'id') || props.id}]`) || {} : get(
       state,
       `inspection.dataSourceValues[${get(props, 'id') || props.id}]`
     ) || {},
    dataSource_values: get(
      state,
      `inspection.dataSourceValues[${get(props, 'id') || props.id}]`
    ) || {},
    selected_users: state.forms.selected_users
    });

const mapDispatchToProps = dispatch => ({
  actionDataSource: (methodName, data, sourceURL, id, filters) => {
    dispatch(fetchDataSoureValues(methodName, data, sourceURL, id, filters));
  },
  fetchPortalUsersList: () => {
    dispatch(getPortalusersForPortaUserlField());
  },
  actionFetchSelectedUsers: () => {
    dispatch(fetchselectedUsers());
  },
  actionGetAvpGlobalDataSource: (gdId, fieldId) => {
    dispatch(getAvpGlobalDataSource(gdId, fieldId));
  },
  actionClear: () => {
    dispatch(clearDataSourceValues());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(PulpoField);
